<template>
    <div class="submain">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="开票进度查询" name="invoice">
                <el-form ref="form" :inline="true" :model="formInvoice" label-width="90px">
                    <el-form-item label="客户订单号：">
                      <el-input v-model="formInvoice.khddh"></el-input>
                    </el-form-item>
                    <el-form-item label="订单编号：">
                      <el-input v-model="formInvoice.xdbh"></el-input>
                    </el-form-item>
                    <el-form-item label="下单客户名：">
                      <el-input v-model="formInvoice.xdkhm"></el-input>
                    </el-form-item>
                    <el-form-item label="开票客户名：">
                      <el-input v-model="formInvoice.kpkhm"></el-input>
                    </el-form-item>
                    <el-form-item label="销售类别：">
                      <el-input v-model="formInvoice.xslb"></el-input>
                    </el-form-item>
                    <el-form-item label="开票类型：">
                      <el-input v-model="formInvoice.kplx"></el-input>
                    </el-form-item>
                    <el-form-item label="开票时间：">
                      <el-col :span="11">
                        <el-date-picker type="date" placeholder="选择日期" v-model="formInvoice.date1" style="width: 100%;"></el-date-picker>
                      </el-col>
                      <el-col class="line" :span="2">-</el-col>
                      <el-col :span="11">
                        <el-date-picker type="date" placeholder="选择日期" v-model="formInvoice.date2" style="width: 100%;"></el-date-picker>
                      </el-col>
                    </el-form-item>
                    <el-form-item style="width: 100%;text-align: right;">
                      <el-button type="primary" @click="onSubmit">搜索</el-button>
                      <el-button>重置</el-button>
                    </el-form-item>
                </el-form>
                <div class="table">
                    <el-table
                    stripe
                        :data="tabledata"
                        show-summary
                        border
                        style="width: 100%">
                        <el-table-column
                        prop="num"
                        label="序号"
                        width="50">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="客户订单号"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="address"
                        label="订单编号">
                        </el-table-column>
                        <el-table-column
                        prop="num"
                        label="发货单号"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="下单客户名"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="address"
                        label="开票客户名">
                        </el-table-column>
                        <el-table-column
                        prop="num"
                        label="合计净额"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="发票号"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="address"
                        label="开票金额">
                        </el-table-column>
                        <el-table-column
                        prop="num"
                        label="销售类别"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="数量"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="address"
                        label="重量">
                        </el-table-column>
                        <el-table-column
                        prop="num"
                        label="产品类型"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="开票类型"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="address"
                        label="劳务名称">
                        </el-table-column>
                        <el-table-column
                        prop="num"
                        label="计量单位"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="开票备注"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="address"
                        label="开票说明">
                        </el-table-column>
                        <el-table-column
                        prop="num"
                        label="开票时间"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="是否邮寄"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="address"
                        label="邮寄单号">
                        </el-table-column>
                        <el-table-column
                        prop="num"
                        label="物流信息"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="是否签收"
                        width="180">
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pages">
                    <el-pagination @current-change="handleCurrentChange" 
                v-model:currentPage="currentPage" :page-size="100" :total="1000" 
                layout="prev, pager, next, jumper" background></el-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane label="欠款查询" name="arrears">
                <el-form ref="form" :inline="true" :model="formArrears" label-width="90px">
                    <el-form-item label="下单客户名：">
                      <el-input v-model="formArrears.xdkhm"></el-input>
                    </el-form-item>
                    <el-form-item label="开票客户名：">
                      <el-input v-model="formArrears.kpkhm"></el-input>
                    </el-form-item>
                    <el-form-item label="公司名称：">
                      <el-input v-model="formArrears.gsmc"></el-input>
                    </el-form-item>
                    <el-form-item label="业务员：">
                      <el-input v-model="formArrears.ywy"></el-input>
                    </el-form-item>
                    <el-form-item style="width: 100%;text-align: right;">
                      <el-button type="primary" @click="onSubmit">搜索</el-button>
                      <el-button>重置</el-button>
                    </el-form-item>
                </el-form>
                <div class="table">
                    <el-table
                    stripe
                        :data="tabledata"
                        border
                        style="width: 100%">
                        <el-table-column
                        prop="num"
                        label="序号"
                        width="50">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="下单客户名"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="address"
                        label="开票客户名">
                        </el-table-column>
                        <el-table-column
                        prop="num"
                        label="最大欠款天数"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="欠款总额"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="address"
                        label="0-预警期">
                        </el-table-column>
                        <el-table-column
                        prop="num"
                        label="预警期内"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="超付款周期"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="address"
                        label="清欠期">
                        </el-table-column>
                        <el-table-column
                        prop="num"
                        label="业务员"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="公司名称"
                        width="180">
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pages">
                    <el-pagination @current-change="handleCurrentChange" 
                v-model:currentPage="currentPage" :page-size="100" :total="1000" 
                layout="prev, pager, next, jumper" background></el-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane label="对账单" name="statement">
                <el-form ref="form" :inline="true" :model="formStatement" label-width="90px">
                    <el-form-item label="公司名称：">
                      <el-input v-model="formStatement.gsmc"></el-input>
                    </el-form-item>
                    <el-form-item label="下单客户：">
                      <el-input v-model="formStatement.xdkhm"></el-input>
                    </el-form-item>
                    <el-form-item label="开票客户：">
                      <el-input v-model="formStatement.kpkhm"></el-input>
                    </el-form-item>
                    <el-form-item label="对账年度">
                      <el-input v-model="formStatement.year"></el-input>
                    </el-form-item>
                    <el-form-item label="对账月份">
                        <el-input v-model="formStatement.month"></el-input>
                      </el-form-item>
                    <el-form-item style="width: 100%;text-align: right;">
                      <el-button type="primary" @click="onSubmit">搜索</el-button>
                      <el-button>重置</el-button>
                    </el-form-item>
                </el-form>
                <div class="table">
                    <el-table
                    stripe
                        :data="tabledata"
                        border
                        style="width: 100%">
                        <el-table-column
                        prop="num"
                        label="序号"
                        width="50">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="公司名称"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="下单客户"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="address"
                        label="开票客户">
                        </el-table-column>
                        <el-table-column
                        prop="num"
                        label="对账年度"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="对账月份"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="address"
                        label="期初金额">
                        </el-table-column>
                        <el-table-column
                        prop="num"
                        label="发货数量"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="发货数量"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="address"
                        label="回款额">
                        </el-table-column>
                        <el-table-column
                        prop="num"
                        label="期末余额"
                        width="180">
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pages">
                    <el-pagination @current-change="handleCurrentChange" 
                v-model:currentPage="currentPage" :page-size="100" :total="1000" 
                layout="prev, pager, next, jumper" background></el-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane label="罚息查询" name="penalty">
                <el-form ref="form" :inline="true" :model="formPenalty" label-width="90px">
                    <el-form-item label="欠款时间：">
                        <el-col :span="11">
                          <el-date-picker type="date" placeholder="选择日期" v-model="formPenalty.date1" style="width: 100%;"></el-date-picker>
                        </el-col>
                        <el-col class="line" :span="2">-</el-col>
                        <el-col :span="11">
                          <el-date-picker type="date" placeholder="选择日期" v-model="formPenalty.date2" style="width: 100%;"></el-date-picker>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="订单编号：">
                      <el-input v-model="formPenalty.ddbh"></el-input>
                    </el-form-item>
                    <el-form-item label="分销客户编号：">
                      <el-input v-model="formPenalty.fxkhbh"></el-input>
                    </el-form-item>
                    <el-form-item label="产品型号/编号：">
                      <el-input v-model="formPenalty.cpxh"></el-input>
                    </el-form-item>
                    <el-form-item style="width: 100%;text-align: right;">
                      <el-button type="primary" @click="onSubmit">搜索</el-button>
                      <el-button>重置</el-button>
                    </el-form-item>
                </el-form>
                <div class="table">
                    <el-table
                    stripe
                        :data="tabledata"
                        border
                        style="width: 100%">
                        <el-table-column
                        prop="num"
                        label="序号"
                        width="50">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="公司名称"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="下单客户"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="address"
                        label="开票客户">
                        </el-table-column>
                        <el-table-column
                        prop="num"
                        label="对账年度"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="对账月份"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="address"
                        label="期初金额">
                        </el-table-column>
                        <el-table-column
                        prop="num"
                        label="发货数量"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="发货数量"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="address"
                        label="回款额">
                        </el-table-column>
                        <el-table-column
                        prop="num"
                        label="期末余额"
                        width="180">
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pages">
                    <el-pagination @current-change="handleCurrentChange" 
                v-model:currentPage="currentPage" :page-size="100" :total="1000" 
                layout="prev, pager, next, jumper" background></el-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane label="回款查询" name="return">
                <el-form ref="form" :inline="true" :model="formReturn" label-width="90px">
                    <el-form-item label="付款客户：">
                      <el-input v-model="formReturn.fkkh"></el-input>
                    </el-form-item>
                    <el-form-item label="下单客户：">
                      <el-input v-model="formReturn.xdkh"></el-input>
                    </el-form-item>
                    <el-form-item label="单据类型：">
                      <el-input v-model="formReturn.djlx"></el-input>
                    </el-form-item>
                    <el-form-item label="来款方式：">
                      <el-input v-model="formReturn.lkfs"></el-input>
                    </el-form-item>
                    <el-form-item label="收款日期：">
                        <el-date-picker type="date" placeholder="选择日期" v-model="formReturn.date1" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="收款公司：">
                      <el-input v-model="formReturn.skgs"></el-input>
                    </el-form-item>
                    <el-form-item style="width: 100%;text-align: right;">
                      <el-button type="primary" @click="onSubmit">搜索</el-button>
                      <el-button>重置</el-button>
                    </el-form-item>
                </el-form>
                <div class="table">
                    <el-table
                    stripe
                        :data="tabledata"
                        border
                        style="width: 100%">
                        <el-table-column
                        prop="num"
                        label="序号"
                        width="50">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="付款客户"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="address"
                        label="下单客户">
                        </el-table-column>
                        <el-table-column
                        prop="num"
                        label="单据类型"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="来款方式"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="address"
                        label="收款金额">
                        </el-table-column>
                        <el-table-column
                        prop="num"
                        label="实收金额"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="已核销金额"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="address"
                        label="收款日期">
                        </el-table-column>
                        <el-table-column
                        prop="num"
                        label="收款银行"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="币种"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="是否调账"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="最后修改人"
                        width="180">
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pages">
                    <el-pagination @current-change="handleCurrentChange" 
                v-model:currentPage="currentPage" :page-size="100" :total="1000" 
                layout="prev, pager, next, jumper" background></el-pagination>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import { ref } from 'vue'

    export default {
        name: 'FinancialInquiry',
        setup() {
            let activeName = ref('invoice')
            let handleClick = (tab, event) => {
          
            }
            let formInvoice = ref({
                khddh: '',
                xdbh: '',
                xdkhm: '',
                kpkhm: '',
                xslb: '',
                kplx: '',
                date1: '',
                date2: '',
            })
            let formArrears = ref({
                xdkhm: '',
                kpkhm: '',
                gsmc: '',
                ywy: '',
            })
            let formStatement = ref({
                gsmc: '',
                xdkhm: '',
                kpkhm: '',
                year: '',
                month: ''
            })
            let formPenalty = ref({
                date1: '',
                date2: '',
                ddbh: '',
                fxkhbh: '',
                cpxh: '',
            })
            let formReturn = ref({
                fkkh: '',
                xdkh: '',
                djlx: '',
                lkfs: '',
                date1: '',
                skgs: ''
            })
            let tabledata = ref([])
            let onSubmit = () => {}
            // 翻页
            let currentPage = ref(1)
            let handleCurrentChange = () => {}
            return {
                activeName,
                handleClick,
                tabledata,
                onSubmit,
                currentPage,
                handleCurrentChange,
                formInvoice,
                formArrears,
                formStatement,
                formPenalty,
                formReturn,
            }
        }
    }
</script>

<style scoped lang="scss">
    .submain {
        padding: 10px;
        padding-bottom: 20px;
        background: #fff;
        ::v-deep(.el-input__inner) {
            height: 30px;
            width: 150px;
        }
        ::v-deep(.el-col-11) {
            max-width: 50%;
        }
        ::v-deep(.el-button) {
            height: 30px;
        }
        .table {
            margin-top: 30px;
        }
        .pages {
            margin-top: 30px;
            ::v-deep(.el-input__inner) {
                height: 25px;
                width: 40px;
            }
            ::v-deep(.el-pagination.is-background .el-pager li:hover) {
                background: rgba(255, 0, 0, 1);
                color: #fff;
            }
        }
    }
</style>